<div
  *renderingPermissionDirective="[
    'FirmwareAdmin',
    'FirmwareReader',
    'FirmwareWriter',
    'ModuleUpdateAdmin',
    'ModuleUpdateReader',
    'ModuleUpdateWriter',
  ]"
  class="modules">
  <dcc-page-title
    class="modules__header-title"
    title="Modules"></dcc-page-title>

  <div class="modules__content">
    <div class="modules-metrics">
      <dcc-billboard
        label="Modules"
        [value]="numberOfModules | number"></dcc-billboard>
      <button
        class="lx-btn-small lx-btn-primary"
        (click)="onModuleCreateClick()">
        Create Module
      </button>
    </div>

    <div class="modules__list">
      <div
        *ngFor="let module of filteredModuleNames"
        class="modules__list__data"
        (click)="goToModuleDetails(module)">
        <div class="modules__list__data__icon">
          <i class="lx-icon {{ module.icon }} "></i>
        </div>
        <div class="modules__list__data__text">
          <a class="modules__list__data__link">{{ module.name }}</a>
          <div class="modules__list__data__description">
            {{ module.description }}
          </div>
        </div>
      </div>
    </div>

    <dcc-footer-items-dropdown
      class="modules__pagination_container__count-select"
      [pageSize]="pageSize"
      (changedPageSize)="
        onPageSizeSelected($event)
      "></dcc-footer-items-dropdown>

    <paginator
      class="modules__pagination_container__page-select"
      [currentPageNumber]="currentPage"
      [endOfSet]="endOfSet"
      [pageNumbers]="numberOfPages"
      (selectedPage)="onPageSelection($event)"></paginator>
  </div>
</div>
